import React, { useState } from "react";
import {
  Search,
  Bell,
  Server,
  Users,
  ShoppingCart,
  Eye,
  Home,
  LifeBuoy
} from "lucide-react";
import "./css/EmployeeDashboard.css";

// NOTE: CSS is embedded here to avoid external file errors


export default function EmployeeDashboard() {

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [activePage, setActivePage] = useState("dashboard");
  const [search, setSearch] = useState("");

  const orders = [
    {
      id: "ORD-1021",
      client: "Rahul Sharma",
      email: "rahul@email.com",
      service: "Web Hosting - Basic",
      domain: "rahulblog.com",
      plan: "Basic",
      status: "Active",
      date: "12 Mar 2026"
    },
    {
      id: "ORD-1019",
      client: "Sarah Khan",
      email: "sarah@email.com",
      service: "Web Hosting - Pro",
      domain: "sarahportfolio.com",
      plan: "Pro",
      status: "Pending",
      date: "10 Mar 2026"
    },
    {
      id: "ORD-1015",
      client: "Amit Patel",
      email: "amit@email.com",
      service: "Web Hosting - Business",
      domain: "amitstore.com",
      plan: "Business",
      status: "Active",
      date: "8 Mar 2026"
    }
  ];

  const clients = [
    { name: "Rahul Sharma", email: "rahul@email.com", country: "India", orders: 3 },
    { name: "Sarah Khan", email: "sarah@email.com", country: "UK", orders: 1 },
    { name: "Amit Patel", email: "amit@email.com", country: "India", orders: 2 }
  ];

  const filteredOrders = orders.filter(
    (o) =>
      o.client.toLowerCase().includes(search.toLowerCase()) ||
      o.domain.toLowerCase().includes(search.toLowerCase())
  );

  const openHosting = (domain) => {
    alert(`Opening hosting panel for ${domain}`);
  };

  const SidebarItem = ({ id, label, icon: Icon }) => (
    <div
      onClick={() => setActivePage(id)}
      className={`sidebar-item ${activePage === id ? "sidebar-active" : ""}`}
    >
      <Icon size={16} />
      {label}
    </div>
  );

  return (
    <>
      

      <div className="dashboard-wrapper">

        <div className="sidebar">
          <div className="sidebar-title">GreenKnowledge</div>

          <SidebarItem id="dashboard" label="Dashboard" icon={Home} />
          <SidebarItem id="clients" label="Clients" icon={Users} />
          <SidebarItem id="orders" label="Orders" icon={ShoppingCart} />
          <SidebarItem id="hosting" label="Hosting Access" icon={Server} />
          <SidebarItem id="support" label="Support" icon={LifeBuoy} />
        </div>

        <div className="main-content">

          <div className="header">

            <div>
              <h1 style={{margin:0,textTransform:"capitalize"}}>{activePage}</h1>
              <p style={{fontSize:13,color:"#6b7280"}}>Employee control panel</p>
            </div>

            <div style={{display:"flex",alignItems:"center",gap:15}}>

              <div className="search-box">
                <Search size={16} color="#9ca3af" />
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search clients or domains..."
                />
              </div>

              <div className="card" style={{padding:8,cursor:"pointer"}}>
                <Bell size={18} />
              </div>

              <div className="profile-avatar" />

            </div>

          </div>

          {activePage === "dashboard" && (
            <div className="stats-grid">

              <div className="card">
                <div style={{display:"flex",gap:12,alignItems:"center"}}>
                  <ShoppingCart color="#16a34a" />
                  <div>
                    <div className="stat-title">Total Orders</div>
                    <div className="stat-value">38</div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div style={{display:"flex",gap:12,alignItems:"center"}}>
                  <Server color="#16a34a" />
                  <div>
                    <div className="stat-title">Active Hosting</div>
                    <div className="stat-value">24</div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div style={{display:"flex",gap:12,alignItems:"center"}}>
                  <Users color="#16a34a" />
                  <div>
                    <div className="stat-title">Registered Clients</div>
                    <div className="stat-value">22</div>
                  </div>
                </div>
              </div>

            </div>
          )}

          {activePage === "clients" && (
            <div className="card">
              {clients.map((c, i) => (
                <div key={i} className="order-row">
                  <div>
                    <div style={{fontWeight:500}}>{c.name}</div>
                    <div style={{fontSize:12,color:"#6b7280"}}>{c.email}</div>
                  </div>
                  <div>{c.country}</div>
                  <div>Orders: {c.orders}</div>
                </div>
              ))}
            </div>
          )}

          {activePage === "orders" && (
            <div className="card">
              <h2 style={{marginTop:0}}>Client Orders</h2>

              {filteredOrders.map((order) => (
                <div key={order.id} className="order-row">

                  <div>
                    <div style={{fontWeight:500}}>{order.client}</div>
                    <div style={{fontSize:12,color:"#6b7280"}}>{order.email}</div>
                  </div>

                  <div>
                    <div style={{fontWeight:500,fontSize:14}}>{order.domain}</div>
                    <div style={{fontSize:12,color:"#6b7280"}}>{order.service}</div>
                  </div>

                  <div style={{fontSize:12,color:"#6b7280"}}>{order.date}</div>

                  <div className="order-actions">

                    <span className={order.status === "Active" ? "status-active" : "status-pending"}>
                      {order.status}
                    </span>

                    <button onClick={() => setSelectedOrder(order)} className="button btn-gray">
                      <Eye size={14}/> Details
                    </button>

                    <button onClick={() => openHosting(order.domain)} className="button btn-green">
                      Open Hosting
                    </button>

                  </div>

                </div>
              ))}

            </div>
          )}

          {activePage === "hosting" && (
            <div className="card">
              Employees can access hosting panels for client domains from the Orders section.
            </div>
          )}

          {activePage === "support" && (
            <div className="card">
              Support ticket system will appear here.
            </div>
          )}

          {selectedOrder && (
            <div className="modal-overlay">
              <div className="modal">
                <h3>Order Details</h3>

                <div style={{fontSize:14,lineHeight:1.8}}>
                  <div><b>Order ID:</b> {selectedOrder.id}</div>
                  <div><b>Client:</b> {selectedOrder.client}</div>
                  <div><b>Email:</b> {selectedOrder.email}</div>
                  <div><b>Domain:</b> {selectedOrder.domain}</div>
                  <div><b>Hosting Plan:</b> {selectedOrder.plan}</div>
                  <div><b>Status:</b> {selectedOrder.status}</div>
                  <div><b>Date:</b> {selectedOrder.date}</div>
                </div>

                <div className="modal-footer">
                  <button onClick={() => setSelectedOrder(null)} className="close-btn">Close</button>
                </div>

              </div>
            </div>
          )}

        </div>

      </div>

    </>
  );
}
